import { ExpressionConditionRender } from '@/features/audienceEdit_v2/components';
import { Audience } from '@/models/audiences';
import { DataSource } from '@/models/dataSource';
import { mapAudienceExpressionToRules } from '@/utils';
import { FC, Fragment } from 'react';
import { Trans, useTranslation } from 'react-i18next';
import { AudienceEstimateCard } from './AudienceEstimateCard';

type AudienceDetailsRulesProps = {
  audience?: Audience;
  datasources?: DataSource[];
};

export const AudienceDetailsRules: FC<AudienceDetailsRulesProps> = ({ audience, datasources }) => {
  const { t } = useTranslation();

  const rules = mapAudienceExpressionToRules(audience?.expression);

  const dataSources = datasources || [];
  return (
    <div>
      <div className='mt-8 flex items-start justify-between gap-8 border-b border-secondary-border pb-10'>
        <div className='flex w-[280px] shrink-0 flex-col gap-2'>
          <h3 className='text-lg font-semibold text-secondary-700'>{t('audience_details:sources_and_rules.rules_title')}</h3>
          <p className='mb-4 text-sm text-tertiary-600'>
            <Trans
              i18nKey={'audience_details:sources_and_rules.rules_subtitle'}
              components={{
                newLine: <br />,
              }}
            />
          </p>
          <AudienceEstimateCard audience={audience} />
        </div>

        <div className='min-w-0 flex-1'>
          {rules.map((rule, index_rule) => {
            return (
              <div key={index_rule} className='flex overflow-hidden bg-white-100 p-0'>
                <div className='flex min-w-0 flex-1 flex-col space-y-2'>
                  <div className='space-y-2 rounded-lg border p-4'>
                    {rule.expressions.map((expression, index_expression) => {
                      return (
                        <Fragment key={index_expression}>
                          {index_expression > 0 && (
                            <div className='flex items-center gap-3'>
                              <div className='whitespace-nowrap text-sm text-quaternary-500'>{t('audience:rules.or')}</div>
                              <div className='h-px flex-1 bg-quaternary-200'></div>
                            </div>
                          )}

                          <div key={index_expression} className='flex items-center py-3'>
                            <ExpressionConditionRender expression={expression} isViewMode={true} datasourceIds={dataSources.map((d) => d.id)} />
                          </div>
                        </Fragment>
                      );
                    })}
                  </div>
                  {index_rule < rules.length - 1 && (
                    <div className='flex items-center gap-3 pb-2'>
                      <div className='h-px flex-1 bg-quaternary-200'></div>
                      <div className='flex size-5 items-center justify-center rounded-full border-2 border-quaternary-200 bg-white-100'>
                        <svg className='size-3 text-quaternary-500' fill='none' stroke='currentColor' viewBox='0 0 24 24'>
                          <path strokeLinecap='round' strokeLinejoin='round' strokeWidth={4} d='M12 6v6m0 0v6m0-6h6m-6 0H6' />
                        </svg>
                      </div>
                      <div className='h-px flex-1 bg-quaternary-200'></div>
                    </div>
                  )}
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
};
